import {
    SET_ATTACHMENT,
    REMOVE_ATTACHMENT,
    REMOVE_ALL_ATTACHMENTS
} from "./UploadAttachmentsType";

const initialState = {
    list: [],
};

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ATTACHMENT:
        case REMOVE_ATTACHMENT:
            return {
                ...state,
                list: action.attachmentList,
            };
        case REMOVE_ALL_ATTACHMENTS:
            return {
                ...state,
                list: [],
            };
        default:
            return state;
    }
};

export { reducers };
